import config from '@config';
import {
  initializeHttp,
  setupCookieUnauthorizedInterceptorFabric,
  setupCsrfInterceptor,
  setupOrganizationSessionInterceptor,
  setupRequestInterceptor,
  setupServerErrorInterceptor,
} from '@gasbi/shared';

// Cookie (BFF) session: the HttpOnly cookie rides along on the same origin by
// itself; X-CSRF marks the request as first-party, a 401 navigates the browser
// to the BFF's /login. setupRequestInterceptor stays for the organizationId
// header - it attaches no Bearer when no token has ever been set.
const instance = initializeHttp(config.VITE_API_URL, [
  setupRequestInterceptor,
  setupCsrfInterceptor,
  // Cookie session (GSB-8274): a 403 `organization_unavailable` reads the session's organization again.
  setupOrganizationSessionInterceptor,
  setupCookieUnauthorizedInterceptorFabric('/api/login'),
  setupServerErrorInterceptor,
]);

export default instance;
